import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  TextField, Button, ModalSimple, media, ScrollContainer,
} from '@pik/pik-ui';

import fraudPrevention, { checkValueLength } from '../../common/utils/fraudPrevention';

import S from './styles';

const ICONS = {
  success: (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.525 17.05L17.6 9.975L16.45 8.85L10.525 14.775L7.525 11.775L6.4 12.9L10.525 17.05ZM12 22.5C10.6333 22.5 9.34167 22.2375 8.125 21.7125C6.90833 21.1875 5.84583 20.4708 4.9375 19.5625C4.02917 18.6542 3.3125 17.5917 2.7875 16.375C2.2625 15.1583 2 13.8667 2 12.5C2 11.1167 2.2625 9.81667 2.7875 8.6C3.3125 7.38333 4.02917 6.325 4.9375 5.425C5.84583 4.525 6.90833 3.8125 8.125 3.2875C9.34167 2.7625 10.6333 2.5 12 2.5C13.3833 2.5 14.6833 2.7625 15.9 3.2875C17.1167 3.8125 18.175 4.525 19.075 5.425C19.975 6.325 20.6875 7.38333 21.2125 8.6C21.7375 9.81667 22 11.1167 22 12.5C22 13.8667 21.7375 15.1583 21.2125 16.375C20.6875 17.5917 19.975 18.6542 19.075 19.5625C18.175 20.4708 17.1167 21.1875 15.9 21.7125C14.6833 22.2375 13.3833 22.5 12 22.5ZM12 21C14.3667 21 16.375 20.1708 18.025 18.5125C19.675 16.8542 20.5 14.85 20.5 12.5C20.5 10.1333 19.675 8.125 18.025 6.475C16.375 4.825 14.3667 4 12 4C9.65 4 7.64583 4.825 5.9875 6.475C4.32917 8.125 3.5 10.1333 3.5 12.5C3.5 14.85 4.32917 16.8542 5.9875 18.5125C7.64583 20.1708 9.65 21 12 21Z" fill="#41D95A" />
    </svg>
  ),
  error: (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.9995 17.5C12.2332 17.5 12.4292 17.421 12.5875 17.2629C12.7458 17.1049 12.825 16.9091 12.825 16.6755C12.825 16.4418 12.746 16.2458 12.588 16.0875C12.4299 15.9292 12.2341 15.85 12.0005 15.85C11.7668 15.85 11.5708 15.929 11.4125 16.0871C11.2542 16.2451 11.175 16.4409 11.175 16.6746C11.175 16.9082 11.254 17.1042 11.4121 17.2625C11.5701 17.4208 11.7659 17.5 11.9995 17.5ZM11.325 13.675H12.825V7.35H11.325V13.675ZM12.0066 22.5C10.6278 22.5 9.33192 22.2375 8.11915 21.7125C6.90638 21.1875 5.84583 20.4708 4.9375 19.5625C4.02917 18.6542 3.3125 17.593 2.7875 16.379C2.2625 15.165 2 13.8678 2 12.4875C2 11.1072 2.2625 9.81003 2.7875 8.59602C3.3125 7.38201 4.02917 6.325 4.9375 5.425C5.84583 4.525 6.90701 3.8125 8.12103 3.2875C9.33503 2.7625 10.6322 2.5 12.0125 2.5C13.3928 2.5 14.69 2.7625 15.904 3.2875C17.118 3.8125 18.175 4.525 19.075 5.425C19.975 6.325 20.6875 7.38333 21.2125 8.6C21.7375 9.81667 22 11.1145 22 12.4934C22 13.8723 21.7375 15.1681 21.2125 16.3809C20.6875 17.5936 19.975 18.6526 19.075 19.5579C18.175 20.4632 17.1167 21.1798 15.9 21.7079C14.6833 22.236 13.3855 22.5 12.0066 22.5ZM12.0125 21C14.3708 21 16.375 20.1708 18.025 18.5125C19.675 16.8542 20.5 14.8458 20.5 12.4875C20.5 10.1292 19.6766 8.125 18.0297 6.475C16.3828 4.825 14.3729 4 12 4C9.65 4 7.64583 4.82343 5.9875 6.4703C4.32917 8.11718 3.5 10.1271 3.5 12.5C3.5 14.85 4.32917 16.8542 5.9875 18.5125C7.64583 20.1708 9.65417 21 12.0125 21Z" fill="#FE3030" />
    </svg>
  ),
};

const renderResult = (result) => {
  if (result && result.resource) {
    const {
      resource, text, success, error, label,
    } = result;

    const isSuccess = success === true;
    const isError = error === true;

    return (
      <S.Result isSuccess={isSuccess} isError={isError}>
        <S.ResultBlock>
          <S.ResultResource dangerouslySetInnerHTML={{ __html: resource }} />
          {!!text && (
            <S.ResultText dangerouslySetInnerHTML={{ __html: text }} />
          )}
        </S.ResultBlock>
        {!!label && (
          <S.ResultLabel>
            {!!label.icon && (
              <S.ResultLabelIcon>
                {ICONS[label.icon]}
              </S.ResultLabelIcon>
            )}
            {!!label.text && (
              <S.ResultLabelText
                isSuccess={isSuccess}
                isError={isError}
                dangerouslySetInnerHTML={{ __html: label.text }}
              />
            )}
          </S.ResultLabel>
        )}
      </S.Result>
    );
  }

  return null;
};

class FraudPrevention extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      result: null,
      modalActive: false,
      modal: null,
      loading: false,
    };
  }

handleChange = (n, v) => {
  this.setState({
    value: v,
  });
};

handleClick = () => {
  const { value } = this.state;

  const check = fraudPrevention(value);

  this.setState({
    loading: true,
    result: null,
  }, () => {
    setTimeout(() => {
      this.setState({
        result: check,
        loading: false,
      });
    }, 1000);
  });
};

  handleKeyDown =(e) => {
    const buttonDisabled = !checkValueLength(e.target.value);

    if (buttonDisabled) {
      return;
    }

    if (e && e.keyCode === 13) {
      this.handleClick();
    }
  }

  showModal = (modal) => {
    this.setState({ modalActive: true, modal });
  };

  hideModal = () => {
    this.setState({ modalActive: false }, () => {
      setTimeout(() => {
        this.setState({ modal: null });
      }, 300);
    });
  };

  renderLinks = () => {
    const { links, screenType } = this.props;

    const isMobile = screenType === 'mobile';

    let Wrapper = React.Fragment;

    if (isMobile) {
      Wrapper = ScrollContainer;
    }

    return (
      <S.Links>
        <Wrapper>
          {links.map(this.renderLink)}
        </Wrapper>
      </S.Links>
    );
  }

  renderLink = (link) => {
    if (link) {
      const { text, modal } = link;

      let onClick = () => {};

      if (modal) {
        onClick = (e) => {
          e.stopPropagation();
          e.preventDefault();

          this.showModal(modal);
        };
      }

      return (
        <S.Link onClick={onClick}>
          <S.LinkText dangerouslySetInnerHTML={{ __html: text }} />
        </S.Link>
      );
    }

    return null;
  };

  renderListItem = (item, i) => {
    if (item && item.text) {
      const { text, isFraud, link } = item;

      const key = `${i}`;

      let itemProps = {
        as: 'div',
        key,
        dangerouslySetInnerHTML: { __html: isFraud ? `<noindex>${text}</noindex>` : text },
        isFraud: !!isFraud,
      };

      if (link) {
        itemProps = {
          ...itemProps,
          as: 'a',
          href: link,
          target: '_blank',
        };
      }

      return (
        <S.ModalContentListItem {...itemProps} />
      );
    }

    return null;
  }

  renderModalContent = () => {
    const { modal } = this.state;

    if (modal) {
      const { title, list } = modal;
      const showList = !!(Array.isArray(list) && list.length);

      return (
        <S.ModalContent>
          {!!title && (
            <S.ModalContentTitle dangerouslySetInnerHTML={{ __html: title }} />
          )}
          {showList && (
            <S.ModalContentList>
              {list.map(this.renderListItem)}
            </S.ModalContentList>
          )}
        </S.ModalContent>
      );
    }

    return null;
  };

  render() {
    const { description } = this.props;

    const {
      value, loading, result, modalActive,
    } = this.state;

    const buttonDisabled = !checkValueLength(value);

    const styles = `
      width: 544px !important;
      padding: 24px;
      
      @media ${media.max768}{
        width: 100% !important;
      }
    `;

    return (
      <S.FraudPrevention>
        <S.Content>
          <S.Left>
            {!!description && (<S.Description dangerouslySetInnerHTML={{ __html: description }} />)}
          </S.Left>
          {this.renderLinks()}
        </S.Content>
        <S.FormWrapper>
          <S.Form>
            <S.InputWrapper>
              <TextField
                name="domain"
                disabled={loading}
                value={value}
                onChange={this.handleChange}
                onKeyDown={this.handleKeyDown}
                autoComplete="off"
                placeholder="Сайт или почта"
                size="l"
                hidePlaceholderOnFocus
              />
            </S.InputWrapper>
            <S.ButtonWrapper>
              <Button
                disabled={buttonDisabled}
                loading={loading}
                text="Проверить"
                size="l"
                onClick={this.handleClick}
                fullWidth
              />
            </S.ButtonWrapper>
          </S.Form>
          {renderResult(result)}
        </S.FormWrapper>
        <ModalSimple active={modalActive} onClose={this.hideModal} styles={styles}>
          {this.renderModalContent()}
        </ModalSimple>
      </S.FraudPrevention>
    );
  }
}

FraudPrevention.propTypes = {
  description: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.shape({})),
  screenType: PropTypes.string.isRequired,
};

FraudPrevention.defaultProps = {
  description: null,
  links: [],
  // title: DATA.title,
  // description: DATA.description,
  // links: DATA.links,
};

const mapStateToProps = ({ appService, appClientService }) => ({
  lang: appService.lang,
  screenType: appClientService.screenType,
});

export default connect(mapStateToProps)(FraudPrevention);
